import agreeCustodianAgreement from './agreeCustodianAgreement';
import backgroundCheckApplicationForm from './backgroundCheckApplicationForm';
import createApplication from './createApplication';
import custodianCheckApplicationForm from './custodianCheckApplicationForm';
import deleteAnswer from './deleteAnswer';
import downloadApplication, { downloadApplicationValidation, downloadTaxFormValidation } from './downloadApplication';
import generateSignLink, { generateSignLinkValidation } from './generateSignLink';
import getApplicationDetails from './getApplicationDetails';
import getApplications from './getApplications';
import getSigningListPDF from './getSigningListPDF';
import recertifyW8BenForm, { recertifyW8BenFormValidation } from './recertifyW8Ben';
import saveFileAnswer from './saveFileAnswer';
import saveMultipleOptionAnswer from './saveMultipleOptionAnswer';
import saveOptionAnswer from './saveOptionAnswer';
import saveTextAnswer from './saveTextAnswer';
import submitApplicationForm from './submitApplicationForm';
import verifyDocumentApplicationForm from './verifyDocumentApplicationForm';

const ApplicationsRequests = {
	getApplicationDetails,
	getApplications,
	createApplication,
	saveTextAnswer,
	saveOptionAnswer,
	saveMultipleOptionAnswer,
	saveFileAnswer,
	deleteAnswer,
	submitApplicationForm,
	backgroundCheckApplicationForm,
	verifyDocumentApplicationForm,
	custodianCheckApplicationForm,
	downloadApplication,
	downloadApplicationValidation,
	downloadTaxFormValidation,
	generateSignLink,
	generateSignLinkValidation,
	recertifyW8BenForm,
	recertifyW8BenFormValidation,
	getSigningListPDF,
	agreeCustodianAgreement,
};

export default ApplicationsRequests;
